import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useItemStore = defineStore('item', () => {
    const kaleidicalItems = ref(null);

    const reset = () => {
        kaleidicalItems.value = { data: [] };
    };

    const store = (params) => {
        return axios.post(`/api/v1/kaleidical/${params.hash}/items`, params);
    };

    const updateItemsQuantity = (params) => {
        return axios.patch(`/api/v1/kaleidical/${params.hash}/items-quantity`, params);
    };

    const updateItem = (params) => {
        return axios.patch(`/api/v1/items/${params.hash}`, params);
    };

    const removeItem = (params) => {
        return axios.delete(`/api/v1/items/${params.hash}`, params);
    };

    const shareKaleidical = (params) => {
        return axios.get(`/api/v1/kaleidical/${params.hash}/share`, {
            params: { platform: params.platform }
        });
    };

    return {
        kaleidicalItems,
        reset,
        store,
        updateItem,
        updateItemsQuantity,
        shareKaleidical,
        removeItem
    };
});
